module.exports = new __parcel__URL__("dark_matter_icon_44.ae452164.png").toString();